//chapter1
export default {
    id : 5,//chapter number
    title : '05. 마킹 공정(Marking) (1)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/05/videos/a05.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '마킹 공정의 의의',
                '레이저 마킹 공정',
            ],
            body2 : [
                '마킹 공정의 의의에 대해 설명할 수 있다.',
                '레이저 마킹 공정에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/05/videos/05.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '레이저 마킹 장비는 스캐닝 속도를 빠르게해야 정확한 문자를 새기는 것이 가능하다.',//html available
                    answer : "2",
                    explain : '레이저 마킹 장비는 스캐닝 속도가 너무 빠르면 정확한 문자를 새기기 어렵다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '마킹 공정이 완료된 패키지는 비전검사를 통해 마킹 공정이 제대로 되었는지를 확인한다.',//html available
                    answer : "1",
                    explain : '마킹 공정 후 검사 작업은 비전검사 장치를 통해 확인한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>마킹 공정의 의의<br>
                        - 반도체 패키지 표면에 고객이 지정하는 회사명, 제품명, 생산일, Lot 번호 등을 무늬, 기호, 숫자, 문자를 수지 성분의 잉크(ink)나 레이저(laser)를 이용하여 새기는 공정 <br>
                        - 제품에 대한 문제 발생 시 제품의 조립 이력을 확인할 수 있음</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>레이저 마킹 공정<br>
                        - 레이저 마킹은 고에너지 밀도를 가지는 레이저 빔을 반도체 패키지 표면에 조사시켜 가열, 용융, 증발시키는 과정을 통해 표면에 마킹이 가능함<br>
                        - 레이저 마킹 시스템은 회사명, 제원, 기호 둥을 생산공정에 구애받지 않고 마킹할 수 있어 신뢰성이 높음<br>
                        - 인쇄, 각인 등의 방법이 갖는 단점을 보완할 수가 있어 레이저 응용분야에서 절단 및 천공기술과 함께 많이 사용되고 있음<br>
                        - 고속, 고정도여서 대량생산이 가능힘<br>
                        - 인쇄상태가 영구적임<br>
                        - 요철면에도 마킹이 가능함</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/05/videos/a05.mp4',
        },
    ]
}